import {
  ACTION_ARGS,
  Arg,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../../utils/spds/metadata';
import { fn, hash } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import FlexRow from '../../../layout/flex/row.gjs';
import Menu from './menu.gjs';
import Super from '../../../core/base.gjs';
import Trigger from './trigger.gjs';
import styles from './base.module.scss';

const METADATA = Metadata.define({
  description: 'Base filter button component with menu',
  extends: [
    pick(ACTION_ARGS, [
      'onClick',
      { name: 'onSelect', description: 'Action triggered when a menu item is selected' },
    ]),
    pick(COMPONENT_STATE_ARGS, ['autofocus', 'disabled', 'open']),
    pick(CONTAINER_ARGS, ['fitContent']),
    pick(CONTENT_ARGS, ['text']),
    pick(MENU_ARGS, ['menuAnchorOffset', 'menuFitContent']),
  ],
  meta: {
    filtered: Arg.boolean({ description: 'Indicates if the filter is active' }),
  },
  name: 'Filter Button',
});

export default class SpdsActionButtonFilterBase extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-filter';
  classesToMap = ['filtered'];
  styles = styles;

  @tracked menuComponent;
  @tracked menuTriggerComponent;

  get menuAnchor() {
    return this.menuTriggerComponent?.baseElement;
  }

  get open() {
    return !!this.args.open;
  }

  <template>
    <FlexRow
      @fitContent={{true}}
      class={{this.classes}}
      data-test-spds-action-button-filter
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          Menu=(component
            Menu
            anchorElement=this.menuAnchor
            anchorOffset=@menuAnchorOffset
            fitContent=@menuFitContent
            onSelect=@onSelect
            open=this.open
            registerComponent=(fn this.registerComponent "menuComponent")
            unregisterComponent=(fn this.unregisterComponent "menuComponent")
          )
          Trigger=(component
            Trigger
            autofocus=@autofocus
            disabled=@disabled
            fitContent=@fitContent
            onClick=@onClick
            open=this.open
            registerComponent=(fn this.registerComponent "menuTriggerComponent")
            text=@text
            unregisterComponent=(fn this.unregisterComponent "menuTriggerComponent")
          )
        )
      }}
    </FlexRow>
  </template>
}

export const ACTION_BUTTON_FILTER_BASE_METADATA = SpdsActionButtonFilterBase.metadata;
